export const formAnchors = {
    FIRST_FORM: 'firstForm',
    SECOND_FORM: 'formStart',
    TOWING_DESTINATION: 'towingDestination',
    PICKUP_DESTINATION: 'pickUpDestination',
    ADDITIONAL_SERVICE_FORM: 'additionalServiceForm',
};
